<template>
  <!-- style="--main-color: initial" -->
  <div id="app" @scroll="handleScroll()">
    <!-- DEFINE HEADER -->
    <HeaderInt v-if="['Account' ].includes($route.name)" />
    <Header v-else :isScrolled="isScrolled" :isScrolledMobile="isScrolledMobile" />
    <!-------------------->
  
    <main class="content-main">
      <router-view/>
    </main>

    <!-- DEFINE MENU -->
    <Menu />
    <!-------------------->

    <!-- DEFINE FOOTER -->
    <Footer />
    <!-------------------->
   <!--- BACKDROP -->
   <div class="backdrop_bar" :class="{ 'd-none': !activeBackdrop }"></div>
    <!-------------------->
     <Login />
  </div>
</template>

<style lang="scss">

@import './assets/scss/generic/mixins.scss';
@import './assets/scss/generic/fonts.scss';
@import './assets/scss/generic/utilities.scss';

:root {
  --main-color: #F15A22;
  --main-color-light: #F21A35;
  --main-color2: #D9B48F;
  --main-color3: #C6AFA0;
  --main-color4: #5E4F47;
  --red: #CC0000;
  --red-2: #F21A35;
  --green: #4AB900;
  --white: #fff;
  --black: #000;
  --gray: #2F2F2F;
  --dark-gray: #787878;
  --swiper-theme-color: #3fba90!important;
}
html,
body {
  margin: 0;
  width: 100%;
  color: #687188;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
.content-main {
  margin-top: 0px;
}
@media (min-width: 992px){
  .container, .container-lg, .container-md, .container-sm {
    max-width: 1100px;
  }
}
@media (min-width: 1500px){
  .container, .container-lg, .container-md, .container-sm, .container-xl {
    max-width: 1640px;
  }
}
.swiper-button-next,
.swiper-button-prev {
  outline: none !important;
  &::after {
    content: none;
  }
}
.swiper-container .swiper-button-next,
.swiper-container .swiper-button-prev {
  background: 0;
  border: 0;
}
.overflow-hidden {
  overflow: hidden;
}
.backdrop_bar {
  position: fixed;
  z-index: 2;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background: rgba(0,0,0,0.6);
}
a {
  text-decoration: none !important;
}
button {
  outline: none !important;
}
p{
  margin-bottom: 0!important;
}
</style>
<script>
import Header from '@/components/headers/Header.vue';
import HeaderInt from '@/components/headers/HeaderInt.vue';
import Menu from '@/components/menus/Menu.vue';
import Footer from '@/components/footers/Footer.vue';
import { mapGetters, mapMutations } from 'vuex';
import Login from "@/components/modals/Login.vue";


export default {
  data() {
    return {
      isScrolled: false,
      isScrolledMobile: false
    }
  },
  components: {
    Header,
    Footer,
    Menu,
    HeaderInt,
    Login,
  },
  computed: {
    ...mapGetters(['isDesktop', "activeBackdrop"])
  },
  created () {
    window.addEventListener('scroll', this.handleScroll);

    const token = this.$store.state.App.token;

    if (token) {
      this.$store.dispatch('App/getUserData', token);
    }
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    ...mapMutations(['setIsDesktop',]),
    handleScroll(event) {
      if (event.currentTarget.innerWidth > 992) {
        if (event.currentTarget.scrollY > 100){
          this.isScrolled = true;
        } else {
          this.isScrolled = false;
        }
      } else {
        if (event.currentTarget.scrollY > 100){
          this.isScrolledMobile = true;
        } else {
          this.isScrolledMobile = false;
        }
      }
    }
  },
  mounted() {
    if (window.innerWidth > 992){
      this.setIsDesktop(true);
    } else {
      this.setIsDesktop(false);
    }
  }
}
</script>
